module.exports = __webpack_public_path__ + "media/images/ecalls/happy_with_bitcoin-d5c215fb312e933cf9b5640c63b7efd3.png";